import type { ExternalTableSchema } from '@packages/table-builder';

export const pushToProductionTable: ExternalTableSchema = {
  metadata: {
    title: 'Load To Main Logs',
    entity: 'PushToProduction',
    description: 'Audit log of sandbox pushes to production.',
  },

  dataSource: {
    endpoint: '/api/identity/api/production',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'sandboxTenantName',
      header: 'Sandbox Tenant Name',
      type: 'text',
      width: 200,
      align: 'left',
      sortable: true,
    },
    {
      field: 'productionTenantName',
      header: 'Production Tenant Name',
      type: 'text',
      width: 200,
      align: 'left',
      sortable: true,
    },
    {
      field: 'userName',
      header: 'Username',
      type: 'text',
      width: 200,
      align: 'left',
      sortable: true,
    },
    {
      field: 'creationTime',
      header: 'Created At',
      type: 'date',
      width: 200,
      align: 'left',
      sortable: true,
    },
    {
      field: 'remarks',
      header: 'Remarks',
      type: 'text',
      width: 200,
      align: 'center',
      sortable: true,
    },
  ],

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
  },
};
